import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { Helmet } from 'react-helmet'; // Import React Helmet
import { AuthProvider, useAuth } from './context/AuthContext';
import Header from './components/Header';
import HomePage from './components/HomePage';
import DocsPage from './components/DocsPage';
import PricingPage from './components/PricingPage';
import FAQPage from './components/FAQPage';
import AboutUsPage from './components/AboutUsPage';
import LoginPage from './components/LoginPage';
import SignUpPage from './components/SignUpPage';
import DashboardPage from './components/DashboardPage';
import PrivacyPolicyPage from './components/PrivacyPolicyPage';
import TOSPage from './components/TOSPage';
import RegionsPage from './components/RegionsPage';
import OtpPage from './components/OtpPage';
import NotFoundPage from './components/NotFoundPage'; // Import a custom 404 page

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

function AppContent() {
  const { currentUser } = useAuth();

  return (
    <Router basename="/">
      <Helmet>
        {/* Default Metadata */}
        <title>SMS Textr | Affordable SMS API</title>
        <meta
          name="description"
          content="Send SMS programmatically with SMS Textr's affordable, pay-as-you-go API. Perfect for developers and small businesses."
        />
        <meta name="keywords" content="SMS API, affordable SMS, SMS integration, developers, small businesses" />
        <meta property="og:title" content="SMS Textr | Affordable SMS API" />
        <meta property="og:description" content="Send SMS programmatically with SMS Textr's affordable, pay-as-you-go API." />
        <meta property="og:url" content="https://smstextr.web.app/" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="SMS Textr | Affordable SMS API" />
        <meta name="twitter:description" content="Send SMS programmatically with SMS Textr's affordable, pay-as-you-go API." />
      </Helmet>
      <Routes>
        {/* Public routes with Header */}
        <Route
          path="*"
          element={
            <>
              <Header />
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/signup" element={<SignUpPage />} />
                <Route path="/docs" element={<DocsPage />} />
                <Route path="/pricing" element={<PricingPage />} />
                <Route path="/faq" element={<FAQPage />} />
                <Route path="/about" element={<AboutUsPage />} />
                <Route path="/privacy" element={<PrivacyPolicyPage />} />
                <Route path="/tos" element={<TOSPage />} />
                <Route path="/regions" element={<RegionsPage />} />
                <Route path="/otp" element={<OtpPage />} />
              </Routes>
            </>
          }
        />
        {/* Ensure the dashboard route is outside the public routes */}
        <Route 
          path="/dashboard" 
          element={
            currentUser ? <DashboardPage /> : <Navigate to="/login" />
          } 
        />
        <Route path="/dashboardpage" element={<Navigate to="/dashboard" replace />} />

        {/* Fallback 404 page */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}

export default App;
